import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import WhatIfResultsListContainer from '../containers/WhatIfResultsListContainer';
import WhatIfResultsCompareContainer from './WhatIfResultsCompareContainer.js';
import WhatIfResultsDetailContainer from './WhatIfResultsDetailContainer.js';
import WhatIfResultsExcelContainer from './WhatIfResultsExcelContainer.js';
import { push } from 'connected-react-router';
import { WHAT_IF_URL } from 'src/constants/constants.js';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver';
import Save from '@material-ui/icons/Save';
import Email from '@material-ui/icons/Email';
import Print from '@material-ui/icons/Print';
import WhatIfHeaderContainer from './WhatIfHeaderContainer';
import { getCountriesDictionary } from '../state/whatIfActions';

class WhatIfResultsContainer extends React.Component {
  state = {
    menuOptions: [
      {
        title: (
          <Fragment>
            <Save />
            &nbsp;Save
          </Fragment>
        ),
        type: 'save',
      },
      {
        title: (
          <Fragment>
            <Email />
            &nbsp;Email
          </Fragment>
        ),
        type: 'email',
      },
      {
        title: (
          <Fragment>
            <Print />
            &nbsp;Print
          </Fragment>
        ),
        type: 'print',
      },
    ],
  };

  componentDidMount() {
    this.props.getCountriesDictionary();
    if (this.props.results.length === 0) {
      this.props.push(WHAT_IF_URL);
    }
  }

  componentDidUpdate() {
    if (this.props.results.length === 0) {
      this.props.push(WHAT_IF_URL);
    }
  }

  handleMenuSelect = (type, tableMeta) => {
    switch (type) {
      case 'save':
        return this.onScreenCapture();
      case 'email':
        return null;
      case 'print':
        return null;
      default:
        return null;
    }
  };

  handleEdit = () => {
    this.props.push(WHAT_IF_URL);
  };

  onScreenCapture = () => {
    const body = document.querySelector('body');
    const props = this.props;
    html2canvas(body, props).then(canvas => {
      let croppedCanvas = document.createElement('canvas');
      var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      var vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      croppedCanvas.width = vw;
      croppedCanvas.height = vh;
      croppedCanvas.style.display = 'block';
      croppedCanvas.style.whiteSpace = 'normal';
      let croppedCanvasContext = croppedCanvas.getContext('2d');

      let width = croppedCanvas.width;
      let height = croppedCanvas.height;

      croppedCanvasContext.drawImage(canvas, 5, 120, width, height, 0, 0, width, height);

      croppedCanvas.toBlob(function(blob) {
        saveAs(blob, 'whatif-' + props.pageType + '.png');
      });
    });
  };

  render() {
    const { results, detailIndex } = this.props;

    const page = [];

    if (results.length > 0) {
      page.push(<WhatIfHeaderContainer {...this.props} />);

      switch (this.props.pageType) {
        case 'detail':
          if (detailIndex !== null) {
            page.push(
              <WhatIfResultsDetailContainer //change to detail pres
                {...this.props}
                {...this.state}
                resultToShow={results[detailIndex]}
                handleMenuSelect={this.handleMenuSelect}
              />,
            );
          }
          break;
        case 'list':
          page.push(
            <WhatIfResultsListContainer
              {...this.props}
              {...this.state}
              handleMenuSelect={this.handleMenuSelect}
              handleEdit={this.handleEdit}
            />,
          );
          break;
        case 'compare':
          page.push(
            <WhatIfResultsCompareContainer //change to compare pres
              {...this.props}
              {...this.state}
              handleMenuSelect={this.handleMenuSelect}
              handleEdit={this.handleEdit}
            />,
          );
          break;
        case 'excel':
          page.push(
            <WhatIfResultsExcelContainer //change to compare pres
              {...this.props}
              {...this.state}
              handleMenuSelect={this.handleMenuSelect}
              handleEdit={this.handleEdit}
            />,
          );
          break;
        default:
          return null;
      }

      return page;
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => ({
  results: state.whatIf.results,
  isLoading: state.whatIf.isLoadingCalculations,
  pageType: state.whatIf.pageType,
  detailIndex: state.whatIf.detailIndex,
});

const mapDispatchToProps = {
  push,
  getCountriesDictionary,
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatIfResultsContainer);
